module.exports = __webpack_public_path__ + "components/outside-promo-page/static/Logotype-baa8891883c10731fc0afddc102f54f7.svg";